<script setup>
import MainLayout from '@/components/layout/MainLayout.vue'
import StatCard from '@/components/dashboard/StatCard.vue'
import MonthlyCollectionCard from '@/components/dashboard/MonthlyCollectionCard.vue'
import QuickActionCard from '@/components/dashboard/QuickActionCard.vue'
import RecentInvoicesTable from '@/components/dashboard/RecentInvoicesTable.vue'
import UnpaidUnitsTable from '@/components/dashboard/UnpaidUnitsTable.vue'
import { useDashboardStore } from '@/stores/dashboard'

const dashboard = useDashboardStore()

const formatCurrency = (value) => {
  return new Intl.NumberFormat('th-TH', {
    style: 'currency',
    currency: 'THB',
    minimumFractionDigits: 0,
  }).format(value)
}
</script>
<template>
  <MainLayout>
    <div class="container-fluid px-0">
      <div class="row g-4 mb-4">
        <div class="col-md-6 col-xl-3">
          <StatCard
            title="ยูนิตทั้งหมด"
            :value="dashboard.stats.totalUnits.toLocaleString('th-TH')"
            subtitle="จำนวนบ้าน / ห้อง ในระบบ"
            icon="bi-buildings"
            color="primary"
          />
        </div>

        <div class="col-md-6 col-xl-3">
          <StatCard
            title="ชำระแล้ว"
            :value="dashboard.stats.paidUnits.toLocaleString('th-TH')"
            subtitle="ยูนิตที่ชำระค่าส่วนกลางแล้ว"
            icon="bi-check-circle"
            color="success"
          />
        </div>

        <div class="col-md-6 col-xl-3">
          <StatCard
            title="ค้างชำระ"
            :value="dashboard.stats.overdueUnits.toLocaleString('th-TH')"
            subtitle="ยูนิตที่ยังมีค้างชำระ"
            icon="bi-exclamation-circle"
            color="danger"
          />
        </div>

        <div class="col-md-6 col-xl-3">
          <StatCard
            title="ยอดจัดเก็บเดือนนี้"
            :value="formatCurrency(dashboard.stats.monthlyCollected)"
            :subtitle="`เป้าหมาย ${formatCurrency(dashboard.stats.monthlyTarget)}`"
            icon="bi-cash-stack"
            color="warning"
          />
        </div>
      </div>

      <div class="row g-4 mb-4">
        <div class="col-xl-8">
          <MonthlyCollectionCard
            :items="dashboard.monthlyCollections"
            :percent="dashboard.collectionPercent"
          />
        </div>

        <div class="col-xl-4">
          <div class="card border-0 shadow-sm rounded-4 h-100">
            <div class="card-body p-4">
              <div class="mb-3">
                <h5 class="fw-bold mb-1">Quick Actions</h5>
                <div class="text-muted small">ทางลัดสำหรับงานที่ใช้บ่อย</div>
              </div>

              <div class="row g-3">
                <div
                  v-for="action in dashboard.quickActions"
                  :key="action.title"
                  class="col-12"
                >
                  <!--
                    ✅ FIX: ส่ง route prop ให้ QuickActionCard
                    dashboard store มี route field อยู่แล้ว แต่ component เดิมไม่รับ prop นี้
                  -->
                  <QuickActionCard
                    :title="action.title"
                    :description="action.description"
                    :icon="action.icon"
                    :color="action.color"
                    :route="action.route"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row g-4">
        <div class="col-xl-7">
          <RecentInvoicesTable :items="dashboard.recentInvoices" />
        </div>

        <div class="col-xl-5">
          <UnpaidUnitsTable :items="dashboard.unpaidUnits" />
        </div>
      </div>
    </div>
  </MainLayout>
</template>
